<template>
  <div class="receipt-action-wrapper">
    <el-dropdown @command="handleCommand" trigger="click">
      <el-button type="primary" size="small">
        收据操作<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item command="print">
          <i class="el-icon-printer"></i> 打印收据
        </el-dropdown-item>
        <el-dropdown-item command="email" divided>
          <i class="el-icon-message"></i> 发送邮件收据
        </el-dropdown-item>
        <el-dropdown-item command="sms">
          <i class="el-icon-mobile-phone"></i> 发送短信收据
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    
    <!-- 发送邮件对话框 -->
    <el-dialog
      title="发送邮件收据"
      :visible.sync="emailDialogVisible"
      width="400px"
      center>
      <el-form :model="emailForm" ref="emailForm" :rules="emailRules" label-width="80px">
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="emailForm.email" placeholder="请输入收件人邮箱"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="emailDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendEmail" :loading="sending">发 送</el-button>
      </span>
    </el-dialog>
    
    <!-- 发送短信对话框 -->
    <el-dialog
      title="发送短信收据"
      :visible.sync="smsDialogVisible"
      width="400px"
      center>
      <el-form :model="smsForm" ref="smsForm" :rules="smsRules" label-width="80px">
        <el-form-item label="手机号" prop="phone">
          <el-input v-model="smsForm.phone" placeholder="请输入收件人手机号"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="smsDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="sendSMS" :loading="sending">发 送</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import printService from '@/utils/printService';

export default {
  name: 'ReceiptAction',
  
  props: {
    // 收据数据
    data: {
      type: Object,
      required: true
    },
    
    // 收据类型：payment/vip/recharge
    type: {
      type: String,
      required: true,
      validator: function(value) {
        return ['payment', 'vip', 'recharge'].indexOf(value) !== -1;
      }
    }
  },
  
  data() {
    return {
      emailDialogVisible: false,
      smsDialogVisible: false,
      sending: false,
      
      emailForm: {
        email: ''
      },
      
      smsForm: {
        phone: ''
      },
      
      // 邮箱验证规则
      emailRules: {
        email: [
          { required: true, message: '请输入收件人邮箱', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱格式', trigger: 'blur' }
        ]
      },
      
      // 手机号验证规则
      smsRules: {
        phone: [
          { required: true, message: '请输入收件人手机号', trigger: 'blur' },
          { pattern: /^1[3456789]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }
        ]
      }
    };
  },
  
  created() {
    // 如果数据中有手机号或邮箱，则自动填充
    if (this.data) {
      if (this.data.customerPhone || this.data.shouji) {
        this.smsForm.phone = this.data.customerPhone || this.data.shouji;
      }
      
      // 如果有账号，可以用作邮箱前缀
      if (this.data.zhanghao) {
        this.emailForm.email = `${this.data.zhanghao}@example.com`;
      }
    }
  },
  
  methods: {
    /**
     * 处理下拉菜单命令
     */
    handleCommand(command) {
      switch (command) {
        case 'print':
          this.printReceipt();
          break;
        case 'email':
          this.emailDialogVisible = true;
          break;
        case 'sms':
          this.smsDialogVisible = true;
          break;
      }
    },
    
    /**
     * 打印收据
     */
    printReceipt() {
      try {
        printService.printReceipt(this.data, this.type);
      } catch (error) {
        this.$message.error('打印失败: ' + error.message);
      }
    },
    
    /**
     * 发送邮件收据
     */
    sendEmail() {
      this.$refs.emailForm.validate(valid => {
        if (!valid) return;
        
        this.sending = true;
        
        printService.sendReceiptByEmail(this.data, this.type, this.emailForm.email)
          .then(response => {
            if (response.code === 0) {
              this.$message.success('邮件发送成功');
              this.emailDialogVisible = false;
            } else {
              this.$message.error('邮件发送失败: ' + response.msg);
            }
          })
          .catch(error => {
            this.$message.error('邮件发送失败: ' + error.message);
          })
          .finally(() => {
            this.sending = false;
          });
      });
    },
    
    /**
     * 发送短信收据
     */
    sendSMS() {
      this.$refs.smsForm.validate(valid => {
        if (!valid) return;
        
        this.sending = true;
        
        printService.sendReceiptBySMS(this.data, this.type, this.smsForm.phone)
          .then(response => {
            if (response.code === 0) {
              this.$message.success('短信发送成功');
              this.smsDialogVisible = false;
            } else {
              this.$message.error('短信发送失败: ' + response.msg);
            }
          })
          .catch(error => {
            this.$message.error('短信发送失败: ' + error.message);
          })
          .finally(() => {
            this.sending = false;
          });
      });
    }
  }
};
</script>

<style scoped>
.receipt-action-wrapper {
  display: inline-block;
}
</style> 